// GET all modules
export function appDataReducerModules(state, action) {
    const modules = action.modules.message.data.map((data) => ({
        id: data.id,
        name: data.name,
        description: data.description,
        readOnly: null,
    }));

    return modules;
}
